import Decimal from 'decimal.js';
import { AMOUNT_RE, RATE_RE, normalizeDecimal } from '../../../shared/lib/numericString';

const Money = Decimal.clone({ precision: 64, rounding: Decimal.ROUND_HALF_UP });
export function decimal(value: string): Decimal {
  return new Money(normalizeDecimal(value));
}
export function validAmount(value: string): boolean {
  return AMOUNT_RE.test(value) && decimal(value).gte(0);
}

// Trading is expressed in the selected pair. The reporting valuation is
// separate and never changes the agreed exchange rate or payment amount.
export function tradeQuote(input: {
  amount: string;
  rate: string;
  paymentBaseRate: string;
  deliveredIsBase: boolean;
  paymentIsBase: boolean;
  paymentDp: number;
}) {
  if (!AMOUNT_RE.test(input.amount) || !RATE_RE.test(input.rate)) return null;
  const amount = decimal(input.amount);
  const rate = decimal(input.rate);
  if (amount.lte(0) || rate.lte(0)) return null;
  const total = amount.times(rate);
  if (total.decimalPlaces() > Math.min(input.paymentDp, 4)) return { error: 'trades.exact_total' };

  let paymentBaseRate: Decimal;
  if (input.paymentIsBase) paymentBaseRate = decimal('1');
  else if (input.deliveredIsBase) paymentBaseRate = decimal('1').div(rate);
  else {
    if (!RATE_RE.test(input.paymentBaseRate) || decimal(input.paymentBaseRate).lte(0)) {
      return { error: 'trades.reporting_required', paymentTotal: total.toFixed(input.paymentDp) };
    }
    paymentBaseRate = decimal(input.paymentBaseRate);
  }
  const deliveredBaseRate = input.deliveredIsBase ? decimal('1') : rate.times(paymentBaseRate);
  // Do not silently round a rate that would fail the database balance CHECK.
  if (paymentBaseRate.decimalPlaces() > 8 || deliveredBaseRate.decimalPlaces() > 8) {
    return { error: 'trades.exact_rates', paymentTotal: total.toFixed(input.paymentDp) };
  }
  return {
    paymentTotal: total.toFixed(input.paymentDp),
    rate: rate.toFixed(),
    deliveredBaseRate: deliveredBaseRate.toFixed(),
    paymentBaseRate: paymentBaseRate.toFixed(),
  };
}
